export default {
    data() {
        return {
            report_loading: false
        }
    },
    watch: {

    },
    methods: {
        getReportExtension(rpt_type) {
            if (rpt_type.indexOf('pdf') >= 0 ||
                rpt_type.indexOf('report') >= 0)
                return `pdf`
            else return `xlsx`
        },
        async generateReport(evt) {
            if (evt && typeof evt.preventDefault == 'function') {
                evt.preventDefault();
            }
            try {
                this.report_loading = true
                const { reportType: rpt_type } = this
                console.log('rpt_type', rpt_type)
                const queryString = this.getQueryString(rpt_type);
                console.log('queryString', queryString)
                const ext = this.getReportExtension(rpt_type);
                const fileName = `${rpt_type}.${ext}`
                await this.$store.dispatch('js_report/downloadDocument', {
                    rpt_type,
                    queryString,
                    fileName,
                })
            } catch (err) {
                console.log("err", err)
                this.doToast(
                    'Error!',
                    'Error Detected. Please consult your System Administrator',
                    'danger'
                )
            } finally {
                this.report_loading = false
            }
        },
    },
}
